/* eslint-disable */
/**
 * Zoom, hover y formato del detalle diario.
 *
 * Estos métodos operan sobre la instancia de PanelLogic y conservan el
 * contrato del prototipo importado. No mantienen estado global propio.
 */
const logic = {
setZoom(a, b, min = 450, max = 1350) {
  let w = Math.max(5, Math.min(max - min, b - a));
  a = Math.max(min, Math.min(max - w, a));
  this.setState({
    zm: [a, a + w],
    drag: null
  });
},
detHover(det, thr) {
  const P = det.pts,
    i = Number.isInteger(this.state.hi) && P[this.state.hi] ? this.state.hi : null,
    dayMin = det.timeMin ?? 450,
    dayMax = det.timeMax ?? 1350,
    [z0, z1] = this.state.zm || [dayMin, dayMax],
    zw = z1 - z0;
  const hm = m => String(Math.floor(m / 60)).padStart(2, '0') + ':' + String(Math.floor(m % 60)).padStart(2, '0');
  const hms = m => hm(m) + ':' + String(Math.round(m * 60 % 60)).padStart(2, '0');
  const fr = e => {
    const r = e.currentTarget.getBoundingClientRect();
    return Math.max(0, Math.min(1, (e.clientX - r.left) / r.width));
  };
  const dr = this.state.drag;
  const ticks = [...Array(7)].map((_, j) => {
    const m = z0 + zw * j / 6;
    return zw < 30 ? hms(m) : hm(m);
  });
  const step = Math.max(1, Math.round(P.filter(p => p.t >= z0 && p.t <= z1).length / 30));
  const zArrows = P.filter(p => p.t >= z0 && p.t <= z1).filter((_, j) => j % step === 0).map(p => {
    const cHi = det.curMax;
    return {
      left: ((p.t - z0) / zw * 100).toFixed(2) + '%',
      rot: p.dir.toFixed(0),
      op: (0.3 + 0.7 * p.cur / cHi).toFixed(2),
      size: (9 + 11 * p.cur / cHi).toFixed(0)
    };
  });
  const setZ = (a, b) => this.setZoom(a, b, dayMin, dayMax);
  const pan = d => () => setZ(z0 + d * zw / 2, z1 + d * zw / 2);
  const daySpan = dayMax - dayMin;
  const full = zw >= daySpan - 0.5;
  const base = {
    thrPath: 'M0 ' + (95 - thr / det.curMax * 90).toFixed(1) + ' H600',
    zVB: ((z0 - 450) / 900 * 600).toFixed(2) + ' 0 ' + (zw / 900 * 600).toFixed(2) + ' 100',
    zBarOn: !full,
    zbL: ((z0 - 450) / 900 * 100).toFixed(2) + '%',
    zbW: (zw / 900 * 100).toFixed(2) + '%',
    zbDown: e => {
      e.preventDefault();
      const r = e.currentTarget.getBoundingClientRect(),
        x = (e.clientX - r.left) / r.width * 900 + 450;
      if (x < z0 || x > z1) {
        setZ(x - zw / 2, x + zw / 2);
        this._zb = {
          x: e.clientX,
          z0: x - zw / 2,
          w: r.width
        };
      } else this._zb = {
        x: e.clientX,
        z0,
        w: r.width
      };
    },
    zbMove: e => {
      const b = this._zb;
      if (!b) return;
      const nz = b.z0 + (e.clientX - b.x) / b.w * 900;
      setZ(nz, nz + zw);
    },
    zbUp: () => {
      this._zb = null;
    },
    zTicks: ticks,
    zArrows,
    zLabel: full ? 'Día completo' : 'Zoom ' + hm(z0) + '–' + hm(z1),
    panL: pan(-1),
    panR: pan(1),
    panColor: full ? '#2a3446' : '#e4e9f0',
    zoomOpts: [['Día', daySpan], ['3 h', 180], ['1 h', 60], ['15 min', 15]].map(([label, w]) => ({
      label,
      bg: Math.abs(zw - w) < 0.5 ? 'rgba(46,179,238,0.16)' : 'transparent',
      color: Math.abs(zw - w) < 0.5 ? '#e4e9f0' : '#8793a6',
      onClick: () => {
        const c = i != null ? P[i].t : (z0 + z1) / 2;
        setZ(c - w / 2, c + w / 2);
      }
    })),
    selD: dr ? 'block' : 'none',
    selL: dr ? (Math.min(dr[0], dr[1]) * 100).toFixed(2) + '%' : '0%',
    selW: dr ? (Math.abs(dr[1] - dr[0]) * 100).toFixed(2) + '%' : '0%',
    hCursor: full ? 'crosshair' : 'grab',
    hWheel: e => {
      const x = fr(e),
        m = z0 + x * zw,
        w = Math.max(5, Math.min(daySpan, zw * Math.exp(e.deltaY * 0.0015)));
      setZ(m - x * w, m - x * w + w);
    },
    hDown: e => {
      e.preventDefault();
      this._dpan = {
        x: e.clientX,
        z0,
        w: e.currentTarget.getBoundingClientRect().width,
        moved: false
      };
    },
    hUp: e => {
      this._dpan = null;
      const d = this.state.drag;
      if (!d) return;
      const a = Math.min(d[0], d[1]),
        b = Math.max(d[0], d[1]);
      if (b - a > 0.01) setZ(z0 + a * zw, z0 + b * zw);else this.setState({
        drag: null
      });
    },
    hMove: e => {
      const x = fr(e),
        m = z0 + x * zw;
      const k = P.length ? Math.max(0, Math.min(P.length - 1, Math.round((m - 450) / 900 * (P.length - 1)))) : null;
      const p = this._dpan;
      if (p && zw < daySpan) {
        const dx = e.clientX - p.x;
        if (Math.abs(dx) > 2) {
          p.moved = true;
          const nz = p.z0 - dx / p.w * zw;
          setZ(nz, nz + zw);
          return;
        }
      }
      if (k !== this.state.hi) this.setState({
        hi: k
      });
    },
    hLeave: () => {
      this._dpan = null;
      this.setState({
        hi: null,
        drag: null
      });
    }
  };
  // Slots without a measurement are NaN; the range covers only measured ones.
  const rg = (k, dp) => {
    const v = P.map(p => p[k]).filter(Number.isFinite);
    return v.length ? Math.min(...v).toFixed(dp) + '–' + Math.max(...v).toFixed(dp) : 'Sin datos';
  };
  if (i == null) return {
    ...base,
    hx: '0%',
    hDisp: 'none',
    hTime: '',
    vCol: '#5a667a',
    vOp: '0.6',
    vA: rg('act', 0),
    vT: rg('tasa', 0),
    vP: (v => v.length ? '0–' + Math.max(...v).toFixed(0) : 'Sin datos')(P.map(p => p.ppaC).filter(Number.isFinite)),
    vO: rg('oxy', 1),
    vTe: rg('temp', 2),
    vC: rg('cur', 0),
    vCd: det.dom,
    vCdRot: String(parseInt(det.dom.split('·')[1]) || 0),
    vD: rg('dep', 1)
  };
  const p = P[i];
  return {
    ...base,
    hx: ((p.t - z0) / zw * 100).toFixed(2) + '%',
    hDisp: 'block',
    hTime: hm(p.t),
    vCol: '#e4e9f0',
    vOp: '1',
    vA: p.act.toFixed(1),
    vT: String(p.tasa),
    vP: p.ppaC.toFixed(0),
    vO: p.oxy.toFixed(1),
    vTe: p.temp.toFixed(2),
    vC: p.cur.toFixed(1),
    vCd: det.card(p.dir) + ' · ' + p.dir.toFixed(0) + '°',
    vCdRot: p.dir.toFixed(0),
    vD: p.dep.toFixed(1)
  };
},
noteVals(det) {
  const [z0, z1] = this.state.zm || [det.timeMin ?? 450, det.timeMax ?? 1350];
  const notes = det.notes || [];
  const active = this.state.nh != null ? notes[this.state.nh] : null;
  return {
    notePins: notes.map((note, index) => ({
      visible: note.minute >= z0 && note.minute <= z1,
      left: ((note.minute - z0) / Math.max(1, z1 - z0) * 100).toFixed(2) + '%',
      label: 'Nota ' + String(Math.floor(note.minute / 60)).padStart(2, '0') + ':' + String(Math.floor(note.minute % 60)).padStart(2, '0'),
      active: index === this.state.nh,
      enter: () => this.setState({ nh: index, ah: null, detailHoverTime: note.minute, hi: null }),
      leave: () => this.setState({ nh: null, detailHoverTime: null }),
    })).filter(note => note.visible),
    noteL: active ? { text: active.text } : null,
  };
},
alC(v, max) {
  if (!v) return '#151d2b';
  const t = Math.min(1, v / max);
  return `oklch(${(0.34 + 0.38 * t).toFixed(3)} ${(0.07 + 0.12 * t).toFixed(3)} 25)`;
},
sfrC(v, tol, stripes) {
  if (v == null) return stripes;
  const d = v - 100;
  if (Math.abs(d) <= tol) return '#1d2738';
  const t = Math.min(1, (Math.abs(d) - tol) / 25);
  return `oklch(${(0.38 + 0.34 * t).toFixed(3)} ${(0.06 + 0.1 * t).toFixed(3)} ${d < 0 ? 250 : 55})`;
}
};

export default logic;
